import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getPowerGenerationInfoQueryOptions() {
  return queryOptions({
    queryKey: ["powerGenerationInfo"],
    queryFn: getPowerGenerationInfo,
    retry: false,
  });
}

async function getPowerGenerationInfo() {
  const response = await DefaultService.powerGenerationInfo();
  return response;
}

type usePowerGenerationInfoOptions = {
  queryConfig?: QueryConfig<typeof getPowerGenerationInfoQueryOptions>;
};

export function usePowerGenerationInfo({
  queryConfig,
}: usePowerGenerationInfoOptions = {}) {
  return useQuery({
    ...getPowerGenerationInfoQueryOptions(),
    ...queryConfig,
  });
}
